import { ICombinedUserData } from 'lib/context';

export const INTERCOM_EVENTS = {
  GUIDE_VIEWED: 'guide-viewed',
  VOICEOVER_USED: 'voiceover-used',
  VIRTUAL_BACKGROUND_USED: 'virtual-background-used',
};

type IntercomEventName = (typeof INTERCOM_EVENTS)[keyof typeof INTERCOM_EVENTS];

export const trackIntercomEvent = (
  userData: ICombinedUserData,
  eventName: IntercomEventName,
  params: object = {}
) => {
  if (window.Intercom) {
    window.Intercom('trackEvent', eventName, {
      ...params,
      app_key: '1!8ziazO3xyDSrTTfyL4Nznjk0G6n3c6l4knFZiIndfoYt1525',
      account_external_id: userData.customerId,
      contact_external_id: userData.userId,
    });
  }
};
